<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <form @submit.prevent="guardar">
                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3>
                                Nuevo correlativo de sobres
                            </h3>
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Iniciales</label>
                            <input type="text" id="campo_sobre_iniciales" class="form-control form-control-sm"
                                v-model="iniciales" required>
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Inicio</label>
                            <input type="number" class="form-control form-control-sm" v-model="inicio" required>
                        </div>
                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Fin</label>
                            <input type="number" class="form-control form-control-sm" v-model="fin" required>
                        </div>

                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Sucursales</label>
                            <select class="form-control form-control-sm" v-model="sucursal_seleccionada" required>
                                <option value="">Seleccionar</option>
                                <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index"
                                    :value="item.codigo">{{
                                        item.nombre }}</option>
                            </select>

                        </div>

                        <div class="col-sm-12 mt-4 mb-3">
                            <b-button type="submit" size="sm" variant="outline-dark btn-block">Guardar</b-button>
                        </div>
                    </b-row>

                </form>
            </b-container>

        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex'
    export default {
        name: 'CrearSobre',
        computed: {
            ...mapState(['id_empresa_seleccionada', 'datos_usuario']),
            ...mapGetters(['ES_ROOT', 'SUCURSALES_SIN_BODEGA_CENTRAL'])
        },
        data() {
            return {
                iniciales: '',
                inicio: '',
                fin: '',
                sucursal_seleccionada: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async guardar() {
                let f = {
                    api: `correlativo-sobres`,
                    formulario: {
                        iniciales: this.iniciales.toUpperCase().trim(),
                        inicio: this.inicio,
                        fin: this.fin,
                        empresa: this.id_empresa_seleccionada,
                        sucursal: this.sucursal_seleccionada

                    }
                }

                await this.guardar_data(f)
                this.$emit('actualizar')

                this.iniciales = ''
                this.inicio = ''
                this.fin = ''
                this.sucursal_seleccionada = ''
                document.getElementById('campo_sobre_iniciales').focus()
            },
            ...mapActions(['guardar_data'])
        },
        mounted() {
            document.getElementById('campo_sobre_iniciales').focus()
        },
    }
</script>

<style></style>
